/*----------------------
PRODUCTS
---------------------- */
ProductsCarousel = {
    init: function () {
        var swiper = new Swiper(".swiper-products", {
            slidesPerView: "auto",
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            freeMode: {
                enabled: true,
                sticky: false,
                momentumBounce: false

            },
        });

    }
};

$(document).ready(function () {
    ProductsCarousel.init();
});
$(document).on('shopify:section:load', function (event) {
    ProductsCarousel.init();
});